<style lang="scss" src='./AlertItem.scss' scoped ></style>
<template src="./AlertItem.html"></template>

<script>
import VuePullRefresh from "vue-pull-refresh";
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";

export default {
  name: "AlertItem",
  components: {
    "vue-pull-refresh": VuePullRefresh,
  },
  data() {
    return {
      alertSelected: {},
      alertTypeArray: [],
    };
  },
  props: {
    alert: {
      required: true,
    },
    alertStatusFilter: {
      required: false,
    }
  },
  computed: {
    ...mapState(["course"]),
    ...mapState('SensorList', {
      rssiRanges: (state) => state.rssiRanges,
    }),
    ...mapGetters("AlertList", ["alertsFiltered"]),

    isCourseType(){
      if( (this.course.facility_type && this.course.facility_type.is_golf_course) 
      || !this.course.facility_type){
        return true;
      }else{
        return false;
      }
    },
  },
  methods: {
    getRssiIcon(sensor) {
      // eslint-disable-next-line
      return require(`@/assets/img/gw/sensor/${this.G_getRssiIcon(sensor, this.rssiRanges)}`);
    },

    loadData() {
    },

    getThresholdViolation(alert) {
      let valueViolation = null;
      if (alert.sensor) {
        let minMax = "min_";
        const alertType = this.consts.AlertType[alert.alert_type_id];
        if (alert.violation === "READING_HIGH") {
          minMax = "max_";
        }

        let alertKey = alertType.key;
        if(alert.is_night_time && alert.alert_type_id == 'GROUND_TEMPERATURE'){
          alertKey = 'night_temp'
        }

        valueViolation = alert.sensor.threshold[minMax + alertKey];
      } else {
        const threshold = alert.station.thresholds.find(
          (t) => t.alert_type_id === alert.alert_type_id
        );
        if (threshold) {
          valueViolation =
            alert.violation === "READING_HIGH" ? threshold.max : threshold.min;
        }
      }

      if (valueViolation != null) {
        return this.G_getMeasurement({
          val: valueViolation,
          uom: alert.alert_type.uom,
          addUnit: true,
          invertUOM: false,
        });
      }

      return "";
    },

    ...mapActions("AlertList", [""]),

    ...mapMutations("AlertList", [
      "setLoading",
      "setAlertStatusFilter",
      "setAlerts",
    ]),
  },

  beforeCreate() {},

  created() {},

  mounted() {
    this.loadData();
  },

  beforeDestroy() {},
};
</script>
